<template>
    <div v-if="totalPages > 1" class="table-footer">
        Page
        <input
            class="table-page"
            v-model="inputPage"
            @change="setPage(inputPage)"
            type="number"
            min="1"
            :max="totalPages"
        />
        of
        {{ totalPages }}

        <button class="table-arrow" @click="setPage(currentPage - 1)" :disabled="currentPage <= 1">
            <LaBaseIcon name="arrow-left" />
        </button>

        <button class="table-arrow" @click="setPage(currentPage + 1)" :disabled="currentPage >= totalPages">
            <LaBaseIcon name="arrow-right" />
        </button>
    </div>
</template>

<script>
import LaBaseIcon from "@/components/BaseIcon.vue";
import { ref, watch } from "vue";

export default {
    name: "UsersPagination",
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        totalItems: {
            type: Number,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            default: 20,
        },
    },
    emits: ["page-change"],
    setup(props, { emit }) {
        const inputPage = ref(props.currentPage);

        // Synchronizuj input s aktuální stránkou
        watch(
            () => props.currentPage,
            (newPage) => {
                inputPage.value = newPage;
            }
        );

        const setPage = (page) => {
            const pageNum = parseInt(page);
            if (pageNum >= 1 && pageNum <= props.totalPages && pageNum !== props.currentPage) {
                emit("page-change", pageNum);
            }
        };

        return {
            inputPage,
            setPage,
        };
    },
    components: {
        LaBaseIcon,
    },
};
</script>

<style lang="scss" scoped>
.table-footer {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $light-grey;
}

.table-arrow,
.table-page {
    width: 2.5rem;
    height: 2.5rem;
    color: $blue;
    border-radius: $normal-radius;
}

.table-arrow {
    margin-left: 0.5rem;
    border: 1px solid $grey;
    background: $white;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background: $light-white;
    }
}

.table-page {
    margin: 0 0.3rem;
    border: 1px solid $grey;
    padding: 0.3rem;
    font-weight: 600;
    background: $white;
    text-align: center;
}

body.dark {
    .table-footer {
        color: $dark-text;
    }

    .table-arrow,
    .table-page {
        border: 1px solid transparent;
        background: $input-background;
        color: $dark-text;
    }

    .table-arrow {
        &:hover:not(:disabled) {
            color: $lime;
        }
    }
}
</style>
